'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_GeneralPracticeAppUpdate$$anon$41(evaluator$31) {
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$41__f_evaluator$7 = null;
  this.Lapp_api_GeneralPracticeAppUpdate$$anon$41__f_evaluator$7 = evaluator$31;
}
export { $c_Lapp_api_GeneralPracticeAppUpdate$$anon$41 as $c_Lapp_api_GeneralPracticeAppUpdate$$anon$41 };
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$41.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$41.prototype.constructor = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$41;
/** @constructor */
function $h_Lapp_api_GeneralPracticeAppUpdate$$anon$41() {
}
export { $h_Lapp_api_GeneralPracticeAppUpdate$$anon$41 as $h_Lapp_api_GeneralPracticeAppUpdate$$anon$41 };
$h_Lapp_api_GeneralPracticeAppUpdate$$anon$41.prototype = $c_Lapp_api_GeneralPracticeAppUpdate$$anon$41.prototype;
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$41.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$41.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_GeneralPracticeAppUpdate$$anon$41__f_evaluator$7.apply__O();
  return ((v !== null) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_GeneralPracticeAppUpdate$$anon$41.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_GeneralPracticeAppUpdate$$anon$41 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_GeneralPracticeAppUpdate$$anon$41, "app.api.GeneralPracticeAppUpdate$$anon$41", ({
  Lapp_api_GeneralPracticeAppUpdate$$anon$41: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_GeneralPracticeAppUpdate$$anon$41 as $d_Lapp_api_GeneralPracticeAppUpdate$$anon$41 };
//# sourceMappingURL=app.api.-General-Practice-App-Update$$anon$41.js.map
